<template>
  <div class="page-goodsDetail">
    <div class="goodsDetail-header">
      <nav class="nav">{{supplier_info.supplier_address&&supplier_info.supplier_address.name}}</nav>
    </div>
    <div class="goodsDetail-main">
      <div class="main-left">
        <div class="swiper-container gallery-top">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide swiper-no-swiping"
              v-for="(item2, index2) in goods_info.image_arr"
              :key="index2"
            >
              <img v-lazy="item2" :key="item2" width="400" :height="String(400*400/375)">
            </div>
          </div>
        </div>
        <div class="swiper-container gallery-thumbs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide pointer"
              v-for="(item2, index2) in goods_info.image_arr"
              :key="index2"
            >
              <img v-lazy="item2" :key="item2" style="width:70px;height:70px;">
            </div>
          </div>
        </div>
        <div class="main-left-txt">
          <div class="main-l-t-amount">
            <span>租赁次数：</span>
            <span>{{goods_info.sales_volume||'0'}}</span>
          </div>
          <div class="main-l-t-favor" @click="addOrRmoveFavor">
            <img
              class="icon-favor"
              :src="isshow?'/static/img/shoucang-hui@2x.png':'/static/img/shoucang-xiangqingye @2x.png'"
            >
            <span :style="{color:(isshow?'#999':'#f9b50b')}">收藏</span>
          </div>
        </div>
      </div>
      <div class="main-right">
        <div class="goods-name line2">{{goods_info.name}}</div>
        <div class="goods-price">{{updateGoods.price_discounts||'¥0.00/天'}}</div>
        <div class="manhui-box">
          <span class="icon-manhui">满惠</span>
          <div>{{updateGoods.discounts||''}}</div>
        </div>
        <div class="config-box clearfix">
          <span class="line-txt to-txt">配 置：</span>
          <div class="to-items">
            <el-popover
              placement="top-start"
              width="400"
              trigger="hover"
              v-for="(v,i) in goods_info.goods_config"
              :key="i"
              :disabled="!v.config_detailed_list"
            >
              <div class="sho" style="width:100%" v-if="v.config_detailed_list">
                <section class="shh" style="margin-bottom: 20px;">
                  <div class="block-txt">配置说明</div>
                  <el-input
                    type="textarea"
                    class="config-input"
                    readonly
                    resize="none"
                    v-model="v.config_detailed_list"
                    :autosize="true"
                  />
                </section>
              </div>
              <el-button
                size="small"
                :class="activeClass == i ? 'active':''"
                slot="reference"
                :disabled="v.config_stock==0"
                @click="chooseConfig(v,i)"
              >{{v.config_name}}</el-button>
            </el-popover>
          </div>
        </div>
        <div v-for="(v,i) in goods_info.goods_shipping" :key="i">
          <div v-if="v.id==active&&v.name!='身份证自提'" class="goods-intro">
            <span
              class="Text"
            >该配置押金为¥{{goods_info.goods_config[activeClass].config_deposit}}</span>
            <router-link target="_blank" class="red" :to="{path:'/download'}">提升额度</router-link>
          </div>
        </div>
        <div class="goods-transition config-box">
          <span>取货方式：</span>
          <el-button
            size="small"
            :class="active == v.id ? 'activec':''"
            v-for="(v,i) in goods_info.goods_shipping"
            :key="i"
            @click="dep(v.id)"
          >{{v.name}}</el-button>
        </div>
        <section class="goods-tips goods-intro">
          <div v-for="(v,i) in goods_info.goods_shipping" :key="i">
            <div v-if="v.id==active" style="display:flex;">
              <span style="width:40px;">提示：</span>
              <div style="flex:1;">
                <p>1、{{v.shipping_tips}}</p>
                <p>2、{{v.name}}请至少提前{{v.advance_hours}}小时下单</p>
                <p>3、起租时间超过17：00当天不计费，归还时间超过00：00计费一天</p>
              </div>
            </div>
          </div>
        </section>
        <div class="config-box">
          <span class="line-txt">时 间：</span>
          <el-date-picker
            v-model="Time"
            value-format="yyyy/MM/dd HH:mm"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeTime"
            :time-arrow-control="true"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
        <div class="config-box">
          <span class="line-txt">数 量：</span>
          <el-input-number v-model="num4" :min="1" @change="handleChange"></el-input-number>
        </div>
        <div class="sect">
          <button class="btn-zu" @click="jumpToBalance">立即租</button>
          <button class="btn-join" @click="addToCart">加入租物车</button>
          <router-link target="_blank" :to="{path:'/download'}">
            <el-button class="btn-deposit">申请免押金</el-button>
          </router-link>
        </div>
      </div>
    </div>
    <div
      class="sho"
      v-if="Object.keys(goods_info).length>0&&goods_info.goods_config[activeClass].config_detailed_list"
    >
      <section class="shh" style="margin-bottom: 20px;">
        <div class="block-txt">配置说明</div>
        <el-input
          type="textarea"
          class="config-input"
          v-if="Object.keys(updateGoods).length>0"
          readonly
          resize="none"
          v-model="updateGoods.configuration_list"
          :autosize="true"
        />
        <!-- <el-input
          type="textarea"
          class="config-input"
          readonly
          resize="none"
          v-model="goods_info.goods_config[activeClass].config_detailed_list"
          :autosize="true"
        />-->
      </section>
    </div>
    <div class="sho">
      <section class="sh">
        <div class="sh-left">
          <div>
            <img class="portrait" :src="supplier_info.icon_image" alt="" srcset="">
          </div>
          <div class="sh-text">
            <p
              class="addres"
            >{{supplier_info.supplier_address&&supplier_info.supplier_address.name}}</p>
            <div class="Time">
              <img class="shijian" src="/static/img/shijian-hei.png" alt="" srcset="">
              <span style="padding-left:11.4px;">{{supplier_info.open_time}}</span>
            </div>
            <div class="Shopaddress">
              <span>地址：</span>
              {{supplier_info.supplier_address&&supplier_info.supplier_address.address_details}}
            </div>
          </div>
        </div>
        <div>
          <router-link
            target="_blank"
            :to="{path:'/SupplierDetail', query:{id:supplier_info.id, sname:supplier_info.supplier_address&&supplier_info.supplier_address.name}}"
          >
            <img class="jindian" src="/static/img/jindianguangguang.png" alt="" srcset="">
          </router-link>
        </div>
      </section>
    </div>
    <div class="sho shh" v-if="goods_recommend.length>0" style="margin-top: 20px;">
      <div class="block-txt">推荐商品</div>
      <div class="recommend-items clearfix">
        <div class="recommend-item" v-for="(item,index) in goods_recommend" :key="index">
          <router-link target="_blank" :to="{path:'/GoodsDetail', query:{id:item.id}}">
            <div class="recommend-box">
              <img :src="item.cover_image" :alt="item.name">
            </div>
            <div class="recommend-cont">
              <p class="recommend-name line2">{{item.name}}</p>
              <p class="recommend-price">￥{{item.goods_config[0].price_preference[0].yuan}}/天</p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div class="tab tabmian">
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="详情" name="first" v-html="goods_info.goods_info"></el-tab-pane>
        <el-tab-pane :label="goods_comment_total" name="second">
          <div class="comment-list">
            <div class="comment" v-for="(item,index) in goods_comment" :key="index">
              <div class="hepr">
                <img
                  class="peopleportrait"
                  :src="item.user_info&&item.user_info.avatar"
                  :onerror="errorImg"
                  :alt="item.user_info&&item.user_info.nickname"
                >
                <div style="padding-left:15px;">
                  <div class="Nickname">{{item.user_info&&item.user_info.nickname}}</div>
                  <div class="Inputcontent text-overflow" :title="item.content">{{item.content}}</div>
                </div>
              </div>
              <div class="commenttime">{{item.create_time}}</div>
            </div>
          </div>
          <div class="load-more" v-if="last_page > 1" @click="getMoreComment">点击此处加载更多</div>
        </el-tab-pane>
        <el-tab-pane label="常见问题" name="third" v-html="supplier_info.common_problem"></el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog title="商品评论（列表可上下滑动）" :visible.sync="dialogVisible" width="1000px" top="50px">
      <div class="comment-list list-scroll">
        <div class="comment" v-for="(item,index) in goods_comment_list" :key="index">
          <div class="hepr">
            <img class="peopleportrait" :src="item.avatar" :onerror="errorImg" :alt="item.nickname">
            <div style="padding-left:15px;">
              <div class="Nickname">{{item.nickname}}</div>
              <div class="Inputcontent text-overflow" :title="item.content">{{item.content}}</div>
            </div>
          </div>
          <div class="commenttime">{{item.create_time}}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  goodsInfo,
  goodsRecommend,
  commentList,
  goodsColl,
  updatePrice,
  getSupplierGoodsDetails
} from "../api/goods/goods";
import { addShoppingCart, getCartNum } from "../api/shoppingcart/shopping_cart";
export default {
  name:'async',
  metaInfo() {
    var that=this
    return {
      title: this.pageName,
      meta: [
      {
        name: 'keywords',
        content: that.pageName+',单反相机租赁,摄像机租赁,镜头租赁,相机租用,摄像机租用,直播设备租赁,录音设备租赁,灯光器材租赁,航拍,摇臂,导播,单反,镜头,灯光,录音设备,摄影人员'
      },
      {
        name: 'description',
        content: that.pageName+',大租行是国内专业为企业和个人提供影视器材租赁的互联网平台，可供租赁的设备有:单反相机、镜头、航拍无人机、gopro摄像机、稳定器、直播设备，影视灯光、录音话筒、轨道、摇臂等专业影视设备。'
      }
    ]
    };
  },
  data() {
    return {
      pageName: "loading",
      errorImg: 'this.src="' + require("../../static/img/user.jpg") + '"',
      dialogVisible: false,
      goods_comment_list: [],

      last_page: 0,

      Time: "",
      goods_info: {
        goods_config: [{ manhui: "", deposit_defalut: "" }]
      },
      param: {
        goods_id: this.$route.query.id || "1191",
        user_id:
          !this.$cookies.get("uid") || this.$cookies.get("uid") == "undefined"
            ? ""
            : this.$cookies.get("uid"),
        token:
          !this.$cookies.get("browser_token") ||
          this.$cookies.get("browser_token") == "undefined"
            ? ""
            : this.$cookies.get("browser_token")
      },
      pickerOptions: {
        start: "08:00",
        step: "00:30",
        end: "18:00",
        disabledDate(time) {
          var d = new Date(),
            t =
              d.getFullYear() +
              "/" +
              (d.getMonth() + 1) +
              "/" +
              d.getDate() +
              " 00:00:00";
          return time.getTime() < new Date(t).getTime();
        }
      },
      goods_config: {},
      credit_line:
        !this.$cookies.get("credit_line") ||
        this.$cookies.get("credit_line") == "undefined"
          ? "0.00"
          : this.$cookies.get("credit_line"),
      goods_recommend: [],
      goods_comment: [],
      goods_comment_total: "评论（0）",
      supplier_info: [],
      updateGoods: {},

      activeClass: 0,
      active: 4,
      num4: "1",
      isshow: true,
      activeName: "first"
    };
  },
  methods: {
    swiperint() {
      var galleryThumbs = new Swiper(".gallery-thumbs", {
        spaceBetween: 10,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true
      });
      var galleryTop = new Swiper(".gallery-top", {
        noSwiping: true,
        thumbs: {
          swiper: galleryThumbs
        }
      });
    },

    dep(i) {
      this.active = i;
      // this.getUpdatePrice();
    },
    handleChange(value) {
      //判断当前套餐的库存
      var max_num = this.goods_info.goods_config[this.activeClass].config_stock;
      if (max_num <= 0) {
        this.num4 = 0;
        this.$message.error("库存不足！");
        return;
      }
      if (value > max_num) {
        this.$nextTick(() => {
          this.num4 = max_num;
        });
        this.$message.error("库存不足,最大库存为" + max_num + "！");
        return;
      }
      // this.getUpdatePrice();
    },
    //收藏和取消收藏
    addOrRmoveFavor() {
      goodsColl(this.param).then(response => {
        if (response.data.status != "error") {
          if (response.data.data.iscoll == 1) {
            this.isshow = false;
          } else {
            this.isshow = true;
          }
          this.$message.success(
            response.data.data.iscoll == 1 ? "收藏成功" : "取消收藏成功"
          );
        }
      });
    },
    //选择商品配置套餐
    chooseConfig(item, i) {
      this.activeClass = i;
      this.goods_config = item;
      this.getUpdatePrice();
    },
    changeTime() {
      if (this.Time) {
        var extra = 0;
        for (var i = 0; i < this.goods_info.shipping_type.length; i++) {
          if (this.goods_info.shipping_type[i].id == this.active) {
            extra = this.goods_info.shipping_type[i].advance_hours;
          }
        }
        var now = new Date();
        var d = new Date(now.getTime() + extra * 3600 * 1000),
          dd = new Date(now.getTime() + extra * 3600 * 1000 + 24 * 3600 * 1000);
        var t = this.parseTime(d),
          tt = this.parseTime(dd);
        if (new Date(this.Time[0]).getTime() < d.getTime()) {
          this.$set(this.Time, 0, t);
        }
        if (new Date(this.Time[1]).getTime() < d.getTime()) {
          this.$set(this.Time, 1, tt);
        }
      } else {
        this.Time = "";
      }
    },
    //更新商品显示价格
    getUpdatePrice() {
      let param = {
        num: this.num4,
        time: [],
        config_id: this.goods_info.goods_config[this.activeClass].config_id
      };
      updatePrice(param).then(response => {
        if (response.data.code != "error") {
          this.updateGoods = response.data.data;
        }
      });
    },
    parseTime(time) {
      var t = new Date(time);
      return (
        t.getFullYear() +
        "/" +
        this.parseNum(t.getMonth() + 1) +
        "/" +
        this.parseNum(t.getDate()) +
        " " +
        this.parseNum(t.getHours()) +
        ":" +
        this.parseNum(t.getMinutes())
      );
    },
    parseNum(num) {
      return num < 10 ? "0" + num : num;
    },
    //加载更多评论
    getMoreComment() {
      this.limit = 0;
      commentList(this.param).then(response => {
        if (response.data.code != "error") {
          this.goods_comment_list = response.data.data.data || [];
          this.goods_comment_total = "评论（" + response.data.data.total + "）";
          this.dialogVisible = true;
        }
      });
    },
    //立即租
    jumpToBalance() {
      //判断是否已选择套餐
      if (
        JSON.stringify(this.goods_info.goods_config[this.activeClass]) == "{}"
      ) {
        this.$message.warning("请选择套餐！");
        return;
      }
      var config_id = this.goods_info.goods_config[this.activeClass].config_id;
      var arr2 = {
        user_id: this.param.user_id,
        browser_token: this.param.token,
        type: 1,
        goods_id: this.param.goods_id,
        num: this.num4,
        config_id: config_id,
        shipping_type: this.active,
        start_time: this.Time ? this.Time[0] : "",
        end_time: this.Time ? this.Time[1] : ""
      };
      addShoppingCart(arr2).then(response => {
        if (response.data.code != "error") {
          this.$store.dispatch("userOrder/changeCartNumAction");
          var arr = {
            Time: this.Time,
            classindex: this.active,
            cart_info_id: [response.data.data]
          };
          this.$router.push({
            path: "/Balance",
            query: arr
          });
        }
      });
    },
    //加入购物车
    addToCart() {
      //判断是否已选择套餐
      if (
        JSON.stringify(this.goods_info.goods_config[this.activeClass]) == "{}"
      ) {
        this.$message.error("请选择套餐！");
        return;
      }
      var arr = {
        user_id: this.param.user_id,
        browser_token: this.param.token,
        goods_id: this.param.goods_id,
        num: this.num4,
        type: 2,
        config_id: this.goods_info.goods_config[this.activeClass].config_id,
        shipping_type: this.active,
        start_time: this.Time ? this.Time[0] : "",
        end_time: this.Time ? this.Time[1] : ""
      };
      addShoppingCart(arr).then(response => {
        if (response.data.code != "error") {
          this.$message.success("添加成功！");
          this.$store.dispatch("userOrder/changeCartNumAction");
        }
      });
    },
    getSupplierGoodsDetails() {
      var params = {
        goods_id: this.$route.query.id||'1191',
        user_id: this.$cookies.get("uid") || "",
        browser_token: this.$cookies.get("browser_token") || ""
      };
      getSupplierGoodsDetails(params).then(response => {
        if (response.data.code != "error") {
          this.goods_info = response.data.data || [];
          this.pageName = this.goods_info && this.goods_info.name;
          //配送方式
          this.active = response.data.data.goods_shipping[0].id;
          //店铺信息
          this.supplier_info = response.data.data.supplier_details;
          //收藏状态
          if (response.data.data.favorite_status == true) {
            this.isshow = false;
          }
          //更新显示价格
          this.getUpdatePrice();
          //图片处理
          this.$nextTick(function() {
            if (!!this.goods_info) {
              this.swiperint();
            }
          });

          this.goods_recommend = response.data.data.goods_recommend.data || [];

          this.goods_comment = response.data.data.goods_comment.data || [];
          this.last_page = response.data.data.goods_comment.last_page;
          this.goods_comment_total =
            "评论（" + response.data.data.goods_comment.total + "）";
        }
      });
    }
  },
  created() {
    this.getSupplierGoodsDetails();
  },
  mounted() {
    setTimeout(() => {
      this.pageName = (this.goods_info && this.goods_info.name) || "async";
    }, 2000);
  }
};
</script>

<style scoped>
.gallery-thumbs .swiper-slide {
  border: 1px solid #e6e6e6;
}
.gallery-thumbs .swiper-slide-thumb-active {
  border: 1px dashed #ff6b56;
}
.page-goodsDetail {
  background: rgb(245, 245, 245);
}
.nav {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  font-size: 22px;
  color: #333;
}
.goodsDetail-header {
  background: #ffffff;
  height: 90px;
  padding-top: 30px;
}
.goodsDetail-main {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.main-left {
  width: 440px;
  height: 570px;
  background: #fff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
}
.gallery-thumbs {
  margin-top: 10px;
}
.main-right {
  width: 737px;
  height: 570px;
  margin-top: 20px;
  background: #fff;
  margin-bottom: 20px;
  padding: 20px;
}
.goods-name {
  font-family: PingFangSC-Medium;
  font-size: 22px;
  color: #333333;
}
.goods-price {
  font-size: 24px;
  color: #eb2525;
  line-height: 33px;
}
.manhui-box {
  display: flex;
  align-items: center;
}
.icon-manhui {
  padding: 0 20px;
  background: #ff6b56;
  border-radius: 5px;
  height: 30px;
  line-height: 30px;
  color: #fff;
}
.manhui-box div {
  font-size: 12px;
  color: #333333;
  line-height: 40px;
  padding-left: 15px;
}

.active {
  background: #ff6b56;
  color: #fff;
  font-weight: bolder;
}
.config-box {
  line-height: 56px;
}
.red {
  font-size: 12px;
  color: #eb2525;
  padding-left: 15px;
}
.Text {
  font-size: 12px;
  color: #999999;
}
.goods-intro {
  padding-left: 77px;
}
.line-txt {
  font-size: 14px;
  color: #333333;
  width: 70px;
  display: inline-block;
}
.to-txt {
  float: left;
}
.to-items {
  float: left;
  width: calc(100% - 80px);
  line-height: 40px;
  padding: 8px 0;
}
.line-txt div {
  display: flex;
  justify-content: space-between;
}
.goods-transition span {
  font-size: 14px;
  color: #333333;
}
.activec {
  background: #ff6b56;
  color: #fff;
  font-weight: bolder;
}
.goods-tips {
  font-size: 12px;
  color: #eb2525;
}
.btn-zu {
  width: 120px;
  height: 40px;
  font-size: 14px;
  color: #ffffff;
  background-image: linear-gradient(-225deg, #ffd778 0%, #fd314a 100%);
  border-radius: 4px;
  border: none;
}
.btn-join {
  width: 120px;
  height: 40px;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #ff6b56;
  background: #fff;
  color: #ff6b56;
  margin-left: 20px;
}
.btn-deposit {
  width: 120px;
  height: 40px;
  font-size: 14px;
  color: #eb2525;
  background: #ffffff;
  border: 1px solid #eb2525;
  border-radius: 4px;
  margin-left: 20px;
}
.sect {
  margin-top: 20px;
}
.main-left-txt {
  line-height: 40px;
  display: flex;
  justify-content: flex-end;
}
.main-left-txt div {
  width: 50%;
}
.sha {
  width: 16px;
  height: 16px;
}
.main-left-txt span {
  font-size: 12px;
  color: #999;
  position: relative;
  top: 1px;
}
.icon-favor {
  width: 16.8px;
  height: 16px;
}
.main-l-t-favor {
  text-align: main-right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.sho {
  width: 1200px;
  margin: 0 auto;
}
.portrait {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: 1px solid #e6e6e6;
}
.sho .sh {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.addres {
  font-size: 18px;
  color: #333333;
}
.shijian {
  width: 13.7px;
  height: 13.7px;
  border-radius: 50%;
}
p {
  margin-top: 0;
  margin-bottom: 0px;
}
.Time {
  font-size: 12px;
  color: #999;
  display: flex;
  align-items: center;
}
.Shopaddress {
  font-size: 12px;
  color: #999;
}
.sh-left {
  display: flex;
  align-items: center;
  height: 100%;
}
.sh-text {
  padding-left: 15.9px;
}
.jindian {
  width: 121px;
  height: 40px;
}
.block-txt {
  font-size: 16px;
  color: #333333;
}
.shh {
  background: #fff;
  padding: 15px;
}
.commodity {
  margin-top: 21px;
  padding-right: 21px;
  margin-left: 21px;
  display: flex;
  justify-content: space-between;
}
.ComDes {
  width: 187px;
  font-size: 12px;
  color: #333333;
  padding-top: 5px;
}
.moneyTime {
  font-size: 14px;
  color: #eb2525;
}
.tab {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 30px;
}
.peopleportrait {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #eee;
}
.Nickname {
  font-size: 14px;
  color: #555;
}
.Inputcontent {
  font-size: 12px;
  color: #999999;
  width:800px;
}
.commenttime {
  font-size: 12px;
  color: #999999;
  width: 120px;
  text-align: main-right;
}
.comment {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 15px;
  margin-bottom: 10px;
}
.hepr {
  display: flex;
  align-items: center;
}
.r {
  height: 22px;
  line-height: 22px;
}
.r span {
  margin-left: 11px;
}
.recommend-item {
  width: 222px;
  float: left;
  margin-right: 15px;
  margin-top: 15px;
  box-shadow: 0 3px 15px #ddd;
}
.recommend-item:nth-child(5n + 5) {
  margin-right: 0;
}
.recommend-box {
  height: 222px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.recommend-box img {
  width: 100%;
  transition: All 0.4s ease-in-out;
  -webkit-transition: All 0.4s ease-in-out;
  -moz-transition: All 0.4s ease-in-out;
  -o-transition: All 0.4s ease-in-out;
}
.recommend-item:hover {
  box-shadow: 4px 2px 15px #999;
}
.recommend-item:hover img {
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  -moz-transform: scale(1.1);
  -o-transform: scale(1.1);
  -ms-transform: scale(1.1);
}
.recommend-cont {
  padding: 5px 10px;
}
.recommend-name {
  height: 40px;
  line-height: 20px;
}
.recommend-price {
  color: #eb2525;
}
.comment-list {
  padding: 10px;
}
.list-scroll {
  max-height: 800px;
  overflow-y: auto;
}
.comment-list .comment:last-child {
  border: 0;
}
.load-more {
  text-align: center;
  font-size: 16px;
  color: #999;
  cursor: pointer;
}
</style>
<style>
.to-items .el-button {
  margin-left: 0;
  margin-right: 10px;
}
.el-button {
  outline: 0;
}
.tab img {
  max-width: 100%;
  height: auto;
}
.config-input .el-textarea__inner {
  margin-top: 10px;
  border: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/GoodsDetail.vue